import axiosWrapper from "common/axiosWrapper";

const baseUrl = "/api/season";

/** Calls the API endpoints for the Season Controller. */
export default class SeasonService {
	/** @returns {Promise<Array>} seasons with health metrics, all games. */
	static async getSeasons() {
		return await axiosWrapper.get(baseUrl);
	}

	/** @returns {Promise<object>} the current season {name, startDate, endDate} for the scoped game. */
	static async getCurrent() {
		return await axiosWrapper.get(`${baseUrl}/current`);
	}

	/** Creates (id 0) or updates a season. @returns {Promise<object>} */
	static async saveSeason(season) {
		return await axiosWrapper.post(baseUrl, season);
	}

	/** Deletes a season. Rejects with 400 when it's referenced by events. */
	static async deleteSeason(id) {
		return await axiosWrapper.delete(`${baseUrl}/${id}`);
	}

	/** @returns {Promise<Array>} events with no season, for the given game. */
	static async getOrphans(gameId) {
		return await axiosWrapper.get(`${baseUrl}/orphans?gameId=${gameId}`);
	}

	/** Sets (or clears, when seasonId is null) the season of a single event. */
	static async assignEvent(eventId, seasonId) {
		return await axiosWrapper.post(`${baseUrl}/assign`, { eventId, seasonId });
	}

	/** Rebuilds the trophy leaderboard for the current season of each game. */
	static async recalculateCurrent() {
		return await axiosWrapper.post(`${baseUrl}/recalculate-current`);
	}
}
